import Seperator from '@components/std-components/Seperator'
import { CentricTypography as Typography } from '@core/component/CentricTypography'
import { TotalViewKeyMap } from '@modules/order/constants/keys'
import useOrderContext from '@modules/order/hooks/use-order-context'
import { orderKPIGlobalTopBarStore } from '@modules/order/stores/OrderKPIGlobalTopBarStore'
import formatCurrencyValueByLocale from '@utils/format-currency-value-by-locale'
import formatNumberByLocale from '@utils/format-number-by-locale'
import { useObserver } from 'mobx-react-lite'
import React from 'react'
import { useTranslation } from 'react-i18next'
import * as css from '../../OrderTopbarKPITotals.css'
import { getKPICurrency } from '@modules/order/utils/get-kpi-currency'
import { nav } from '@stores'

const OrderTopbarKPITotals: React.FC<any> = () => {
  return useObserver(function useHook() {
    const {
      uiStore: {
        quantityTypeStore: { type }
      }
    } = useOrderContext()
    const { summary } = orderKPIGlobalTopBarStore.orderKPIsForGlobalTopBar
    const currency = getKPICurrency(nav.queryParams.orderType, summary)
    const kpis = summary?.doorOrder || summary?.clientOrder
    const totalSkus =
      summary?.clientOrder?.productCount || summary?.doorOrder?.productCount || 0
    const { t } = useTranslation()
    return (
      <div className={css.totalsWrapper}>
        <Seperator
          orientation='vertical'
          seperatorStyle='solid'
          seperatorColor='rgba(192,192,192,1)'
          size='20px'
          seperatorThickness='1px'
          margin='4px 16px'
        />
        <div className={css.qtyWrapper}>
          <div className={css.topBarLabel}>
            <Typography variant={'subtitle1Grey'}>
              {t('showroom.orderTopbarKPITotals.totalSKUS', 'TOTAL SKUS')}
            </Typography>
          </div>
          <div className={css.valueContainer}>
            <Typography variant={'h6'}>{formatNumberByLocale(totalSkus)}</Typography>
          </div>
        </div>
        <Seperator
          orientation='vertical'
          seperatorStyle='solid'
          seperatorColor='rgba(192,192,192,1)'
          size='20px'
          seperatorThickness='1px'
          margin='4px 16px'
        />
        <div className={css.qtyWrapper}>
          <div className={css.topBarLabel}>
            <Typography variant={'subtitle1Grey'}>
              {t('showroom.orderTopbarKPITotals.totalQuantity', 'TOTAL QUANTITY')}
            </Typography>
          </div>
          <div className={css.valueContainer}>
            <Typography variant={'h6'}>
              {formatNumberByLocale(kpis?.[TotalViewKeyMap[type]?.totalQuantity]) || 0}
            </Typography>
          </div>
        </div>
        <Seperator
          orientation='vertical'
          seperatorStyle='solid'
          seperatorColor='rgba(192,192,192,1)'
          size='20px'
          seperatorThickness='1px'
          margin='4px 16px'
        />
        <div className={css.qtyWrapper}>
          <div className={css.topBarLabel}>
            {' '}
            <Typography variant={'subtitle1Grey'}>
              {t('showroom.orderTopbarKPITotals.totalValue', 'TOTAL VALUE')}
            </Typography>
          </div>
          <div className={css.valueContainer}>
            <Typography variant={'h6'}>
              {formatCurrencyValueByLocale(
                currency ?? '',
                kpis?.[TotalViewKeyMap[type]?.totalValue] || 0
              )}
            </Typography>
          </div>
        </div>
      </div>
    )
  })
}

export default OrderTopbarKPITotals
